import req from 'shared/req';
import {endsWith, isEmpty} from 'lodash';
import CRUDService from './CRUDService';
import browserHistory from 'shared/history';
import NotFoundError from 'src/utils/error-middlewear/status-errors/not-found-error';

export default class FeatureInteractionService {
  static URL = '/v1/users/me/feature-interactions';

  private static createUrl(featureName: string): string {
    return `${FeatureInteractionService.URL}/${featureName}`;
  }

  static async get<T>(featureName: string, fields: string | string[]): Promise<T> {
    let response;

    if (Array.isArray(fields)) {
      fields = fields.join(',');
    }

    try {
      response = await req({
        url: FeatureInteractionService.createUrl(featureName),
        method: 'get',
        data: isEmpty(fields) ? {} : {fields},
      });
    } catch {
      // means the feature doesn't exist
    }

    return response;
  }

  static async patch<T>(featureName: string, featureData: Partial<T>): Promise<T> {
    return req({
      url: FeatureInteractionService.createUrl(featureName),
      method: 'patch',
      data: {featureData},
    });
  }

  static async post<T>(featureName: string, featureData: T = {} as T): Promise<T> {
    return req({
      url: FeatureInteractionService.URL,
      method: 'post',
      data: {
        featureData: {
          featureName,
          ...featureData,
        },
      },
    });
  }
}

export function showModalOnce(
  featureInteractionId: string,
  endsWithPath: string,
  redirectPath: string
) {
  NewFeatureInteractionService.show(featureInteractionId).catch((errors) => {
    for (const error of errors) {
      if (error instanceof NotFoundError) {
        if (endsWith(browserHistory.location.pathname, endsWithPath)) {
          return;
        }

        browserHistory.push({
          pathname: redirectPath,
          state: {skipScrolling: true},
        });

        return;
      }
    }

    throw errors[0];
  });
}

export const NewFeatureInteractionService = new CRUDService({
  baseUrl: '/v1/users/me/feature-interactions',
  wrapErrors: true,
});
